import { render, staticRenderFns } from "./WFreezer.vue?vue&type=template&id=750ceff8&"
import script from "./WFreezer.vue?vue&type=script&lang=ts&"
export * from "./WFreezer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports